import React from 'react';
import './SelectedDevs.css'
const SelectedDevs = (props) => {
    const { devData } = props;
    let numOfDev = 0;
    let salary = 0;
    let devName = "";
    let devNameArray = [];
    for (const devs of devData) {
        if (!devName.includes(devs.name)) {
            salary = salary + devs.salary;
            devName = devName + " " + devs.name
            devNameArray.push(devs.name);
            numOfDev = numOfDev + 1;
        }
    }
    return (
        <div>

            <p>Number of Devs selected: {numOfDev} </p>
            <p>Cost Of selected devs: ${salary}</p>
            <ul> <h4 className='selected-name'>Selected Dev Names</h4>{
                devNameArray.map(name => <li key={name}>{name}</li>)
            }
            </ul>
        </div>
    );
};

export default SelectedDevs;